import { CSSProperties } from 'react'

export const appStyles: Record<string, CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    fontFamily: 'sans-serif',
  },
  header: {
    padding: '16px 24px',
    backgroundColor: '#c0392b',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  headerTitle: {
    margin: 0,
    fontSize: '20px',
  },
  headerFilename: {
    fontSize: '14px',
    opacity: 0.8,
  },
  backButton: {
    padding: '8px 16px',
    backgroundColor: 'transparent',
    color: 'white',
    border: '1px solid white',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
  },
  listContainer: {
    flex: 1,
    padding: '24px',
    overflowY: 'auto',
  },
  content: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },
  leftPanel: {
    flex: 1,
    padding: '16px',
    borderRight: '1px solid #eee',
    overflow: 'hidden',
  },
  rightPanel: {
    flex: 1,
    padding: '16px',
    overflow: 'hidden',
  },
}
